module.exports = __webpack_public_path__ + "img/check_primary.cd7f293e.png";